import { selectVirtualBackgroundStatus } from 'features/virtual-backgrounds/selectors';
import { call, cancelled, put, select } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import {
  virtualBackgroundActivationFailed,
  virtualBackgroundChanged,
  virtualBackgroundChangeFulfilled,
  virtualBackgroundChangeStarted,
  virtualBackgroundSelected,
} from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { selectLocalVideoBroadcasting } from 'features/streaming/streamingSlice';
import {
  SelectedVirtualBackground,
  VirtualBackgroundsStatus,
} from 'features/virtual-backgrounds/types';

export function* changeVirtualBackgroundSaga(action: PayloadAction<SelectedVirtualBackground>) {
  const videoBroadcasting: boolean = yield select(selectLocalVideoBroadcasting);
  if (!videoBroadcasting) {
    yield put(virtualBackgroundSelected(action.payload, { sync: true }));
    return;
  }

  const status: VirtualBackgroundsStatus = yield select(selectVirtualBackgroundStatus);
  if (status === 'updating') {
    return;
  }

  yield put(virtualBackgroundChangeStarted());

  try {
    const applied: boolean = yield call(
      RTCClient.publishingFeed.changeVirtualBackground,
      action.payload
    );

    if (applied) {
      yield put(virtualBackgroundChanged(action.payload, { sync: true }));
    } else {
      // The feed already reported the failure (if any); this only releases the in-flight guard.
      yield put(virtualBackgroundChangeFulfilled());
    }
  } catch (error) {
    yield put(virtualBackgroundActivationFailed({ reason: 'failed', requested: action.payload }));
  } finally {
    // takeLatest cancellation (another change request superseding this one) skips both
    // try and catch — this is the only path left to release the 'updating' guard.
    const wasCancelled: boolean = yield cancelled();
    if (wasCancelled) {
      yield put(virtualBackgroundChangeFulfilled());
    }
  }
}
